export default function Benefits() {
  const benefits = [
    {
      image: "https://public.readdy.ai/ai/img_res/dca63353a4c1d5cd8f35bf4bfb442244.jpg",
      title: "ATENCIÓN PERSONALIZADA",
      description: "Cada persona es única. Te escucho, entiendo tus necesidades y te oriento de forma individual, sin soluciones genéricas.",
    },
    {
      image: "https://public.readdy.ai/ai/img_res/edited_c84e3573e9b84cf39873fccd4b7fb6df_25b99161.jpg",
      title: "INFORMACIÓN CLARA",
      description: "Explico todo en lenguaje simple y directo. Sin tecnicismos innecesarios ni letra chica, para que tomes decisiones con confianza.",
    },
    {
      image: "https://readdy.ai/api/search-image?query=two%20people%20walking%20together%20on%20a%20bright%20path%2C%20support%20and%20companionship%20concept%2C%20clean%20white%20airy%20background%2C%20warm%20soft%20light%2C%20minimal%20modern%20style%2C%20high%20quality%20photography&width=600&height=400&seq=ben3&orientation=landscape",
      title: "ACOMPAÑAMIENTO CERCANO",
      description: "No estás solo en el proceso. Te acompaño desde la primera consulta hasta después de contratar, con respuesta rápida y trato humano.",
    },
  ];

  return (
    <section className="py-28 lg:py-36 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-20">
          <p className="text-sm font-semibold tracking-widest text-gray-400 uppercase mb-4">
            Beneficios
          </p>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
            Por qué elegir esta asesoría
          </h2>
          <p className="text-lg text-gray-500 leading-relaxed">
            Un servicio pensado en ti, con atención humana y profesional
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid md:grid-cols-3 gap-10 lg:gap-14">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex flex-col items-center text-center">
              {/* Title */}
              <h3 className="text-sm font-bold tracking-widest text-gray-900 uppercase mb-5">
                {benefit.title}
              </h3>

              {/* Divider */}
              <div className="w-8 h-px bg-gray-300 mb-5"></div>

              {/* Description */}
              <p className="text-gray-500 leading-relaxed text-base max-w-xs">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}